import * as Yup from "yup";

const produtoValidator = Yup.object().shape({
  ativado: Yup.boolean().nullable(),
  imagem: Yup.string().nullable(),
  codigoBarra: Yup.string().nullable(),
  grupoProdutoId: Yup.number().nullable().required("Grupo de Produto"),
  tipo: Yup.string().required("Tipo"),
  descricao: Yup.string().required("Descrição"),
  unidadeComercialCompraId: Yup.number()
    .nullable()
    .required("Unidade Comercial de Compra"),
  unidadeComercialVendaId: Yup.number()
    .nullable()
    .required("Unidade Comercial de Venda"),
  conversorEntrada: Yup.number().nullable(),
  estoqueAtual: Yup.number().nullable(),
  fracionavel: Yup.boolean().nullable(),
  lerPesoPorBalanca: Yup.string().nullable(),
  precoCompra: Yup.mixed().test(
    "is-number",
    "Preço de compra",
    (value) => value && !isNaN(Number(value)),
  ),
  precoCusto: Yup.mixed().test(
    "is-number",
    "Preço de custo",
    (value) => value && !isNaN(Number(value)),
  ),
  precoVenda: Yup.mixed().test(
    "is-number",
    "Preço de venda",
    (value) => value && !isNaN(Number(value)),
  ),
  precoMedio: Yup.number().nullable(),
  lucroDesejado: Yup.number().nullable(),
  grupoTributacaoId: Yup.number().when(
    "envioKitItensFiscal",
    (envioKitItensFiscal) => {
      return envioKitItensFiscal
        ? Yup.number().nullable().optional()
        : Yup.number().required("Grupo tributário");
    },
  ),
  //modeloTributacaoId:Yup.number().required("Modelo de tributação"),
  tipoItemId: Yup.number().nullable(),
  ncmId: Yup.string().when("envioKitItensFiscal", (envioKitItensFiscal) => {
    return envioKitItensFiscal
      ? Yup.string().nullable().optional()
      : Yup.string().nullable().required("NCM");
  }),
  ncmCodigo: Yup.string().when("envioKitItensFiscal", (envioKitItensFiscal) => {
    return envioKitItensFiscal
      ? Yup.string().nullable().optional()
      : Yup.string()
          .min(8, "NCM deve ter pelo menos 8 caracteres")
          .nullable()
          .required("NCM");
  }),
  cestId: Yup.number().nullable(),
  gtin: Yup.string().nullable(),
  origemMercadoriaId: Yup.number().required("Origem da mercadoria"),
  aliquotaMva: Yup.number().nullable(),
  informacaoAdicionalNfe: Yup.string().nullable(),
  informacaoComplementar: Yup.string().nullable(),
  produtosSimilaresIds: Yup.array().required(),
  produtosKitIds: Yup.array().when("tipo", (tipo) => {
    return tipo === "kit"
      ? Yup.array().min(2, "Inserir ao menos 2 produtos ao kit")
      : Yup.array().nullable();
  }),
  fornecedores: Yup.array().when("tipo", (tipo) => {
    return tipo === "kit"
      ? Yup.array().nullable()
      : Yup.array().of(
          Yup.object().shape({
            id: Yup.number(),
            codigoProduto: Yup.string(),
            quantidadeEmbalagem: Yup.number().nullable(),
          }),
        );
  }),
  produtosGrade: Yup.array().when("tipo", (tipo) => {
    return tipo === "grade"
      ? Yup.array()
          .min(1, "Ter ao menos um produto na grade")
          .of(
            Yup.object()
              .shape({
                descricao: Yup.string().required("Descrição na grade"),
                codigoBarra: Yup.string().nullable().optional(),
                eixoX: Yup.number().nullable(),
                eixoY: Yup.number().nullable(),
              })
              .required("Ter ao menos um produto na grade"),
          )
          .required("Ter ao menos um produto na grade")
      : Yup.array().nullable();
  }),
  tagsIds: Yup.array().nullable(),
  hubVendas: Yup.boolean().nullable().optional(),
  altura: Yup.number().when("hubVendas", (hubVendas) => {
    return hubVendas
      ? Yup.mixed().test(
          "is-number",
          "Altura",
          (value) => value && !isNaN(Number(value)),
        )
      : Yup.number().nullable().optional();
  }),
  largura: Yup.number().when("hubVendas", (hubVendas) => {
    return hubVendas
      ? Yup.mixed().test(
          "is-number",
          "Largura",
          (value) => value && !isNaN(Number(value)),
        )
      : Yup.number().nullable().optional();
  }),
  comprimento: Yup.number().when("hubVendas", (hubVendas) => {
    return hubVendas
      ? Yup.mixed().test(
          "is-number",
          "Comprimento",
          (value) => value && !isNaN(Number(value)),
        )
      : Yup.number().nullable().optional();
  }),
  peso: Yup.number().when("hubVendas", (hubVendas) => {
    return hubVendas
      ? Yup.mixed().test(
          "is-number",
          "Peso",
          (value) => value && !isNaN(Number(value)),
        )
      : Yup.number().nullable().optional();
  }),
  pesoLiquido: Yup.number().nullable().optional(),
  referenciaPeca: Yup.string().nullable().optional(),
  dataValidade: Yup.date()
    .nullable()
    .when("isMedicamento", {
      is: true,
      then: Yup.date().required("Data de Validade"),
    }),
  dataFabricacao: Yup.date()
    .nullable()
    .when("isMedicamento", {
      is: true,
      then: Yup.date().required("Data de Fabricação"),
    }),
  precoMaxConsumo: Yup.number()
    .nullable()
    .when("isMedicamento", {
      is: true,
      then: Yup.number().required("Preço Máximo de Consumo"),
    }),
  numLote: Yup.number()
    .nullable()
    .when("isMedicamento", {
      is: true,
      then: Yup.number().required("Número de Lote"),
    }),
  qtdLote: Yup.number()
    .nullable()
    .when("isMedicamento", {
      is: true,
      then: Yup.number().required("Quantidade de Lote"),
    }),
  agregado: Yup.number()
    .nullable()
    .when("isMedicamento", {
      is: true,
      then: Yup.number().required("Agregado"),
    }),
  prodAnvisa: Yup.string()
    .nullable()
    .when("isMedicamento", {
      is: true,
      then: Yup.string().required("Prod. ANVISA"),
    }),
  motivoIsencao: Yup.string()
    .nullable()
    .when("isMedicamento", {
      is: true,
      then: Yup.string().required("Motivo Isenção"),
    }),
  anpCodigo: Yup.string()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.string().required("Código ANP"),
    }),
  anpDescricao: Yup.string()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.string().required("Código ANP"),
    }),
  unidadeTributavelId: Yup.string().nullable(),
  qtdTributavel: Yup.number().nullable(),
  glp: Yup.number()
    .nullable()
    .when(["isCombustivel", "anpCodigo"], {
      is: (isCombustivel, anpCodigo) =>
        isCombustivel && anpCodigo === "210203001",
      then: Yup.number().nullable().required("GLP"),
    }),
  gasNaturalNacional: Yup.number()
    .nullable()
    .when(["isCombustivel", "anpCodigo"], {
      is: (isCombustivel, anpCodigo) =>
        isCombustivel && anpCodigo === "210203001",
      then: Yup.number().nullable().required("Gás Natural Nacional"),
    }),
  gasNaturalImp: Yup.number()
    .nullable()
    .when(["isCombustivel", "anpCodigo"], {
      is: (isCombustivel, anpCodigo) =>
        isCombustivel && anpCodigo === "210203001",
      then: Yup.number().nullable().required("Gás Natural Importado"),
    }),
  valorPartida: Yup.number()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.number().required("Valor de partida"),
    }),
  codif: Yup.string()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.string().required("CODIF"),
    }),
  qtdCombTempAmbiente: Yup.number()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.number().required(
        "Quantidade de Combustível em Temperatura Ambiente",
      ),
    }),
  bcCide: Yup.number()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.number().required("BC da CIDE"),
    }),
  aliquotaCide: Yup.number()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.number().required("Alíquota da CIDE"),
    }),
  valorCide: Yup.number()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.number().required("Valor da CIDE"),
    }),
  indicadorImportacao: Yup.string()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.string().required("Indicador de Importação"),
    }),
  ufOrigem: Yup.string()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.string().required("UF de Origem"),
    }),
  percentualUf: Yup.number()
    .nullable()
    .when("isCombustivel", {
      is: true,
      then: Yup.number().required("Percentual Originário para UF"),
    }),
  /*  variacoesProdutoGrade: Yup.array().when("tipo", {
    is: "grade",
    then: Yup.array()
      .min(1, "Ter ao menos uma variação de grade")
      .of(
        Yup.object()
          .shape({
            descricaoProduto: Yup.string().required(),
            coluna: Yup.string().required(),
            valor: Yup.string().nullable(),
          })
          .required("Ter ao menos um produto na grade")
      )
      .required("Ter ao menos um produto na grade"),
  }), */
});

export default produtoValidator;
